import { SvgConsumer } from '@components/icons/svgConsumer';
import { AppTooltip } from '../tooltip/tooltip';
import { ReactNode } from 'react';

export const FormTooltip = ({ children }: { children: ReactNode }) => (
  <AppTooltip side="right" align="center" context={<span>{children}</span>}>
    <span>
      <SvgConsumer className="shrink-0 text-m" id="tooltip" />
    </span>
  </AppTooltip>
);
